import Vue from 'vue';
import VueRouter from 'vue-router';
import { LoadingBar } from 'view-design';
import routes from './routes';
import Cookies from 'js-cookie';
import Store from '@/store';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
// https://github.com/hsingyin/hsingyin.site/issues/7#issue-586782745
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => error);
};

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  LoadingBar.start();

  if (!Cookies.get('user') && to.name !== 'login') {
    Store.dispatch('getUserInfo')
      .then((user) => {
        if (user && user.account) {
          Cookies.set('user', user.account);
          next();
        } else {
          next({
            name: 'login',
          });
        }
      })
      .catch(() => {
        next({
          name: 'login',
        });
      });
  } else if (!Cookies.get('user') && to.name === 'login') {
    next();
  } else if (Cookies.get('user') && to.name === 'login') {
    next({
      name: 'home',
    });
  }

  next();
});

router.afterEach((route) => {
  const title = route.meta.title;
  if (title) {
    document.title = title;
  }
  LoadingBar.finish();
});

export default router;
